





























import Vue from "vue"
import EditLinkIcon from "~/components/guideline/icon/EditLinkIcon.vue"

export default Vue.extend({
  components: {
    EditLinkIcon,
  },
  props: {
    projectTitle: {
      type: String,
      required: true,
    },
    formPath: {
      type: String,
      default: null,
    },
    isClosingApplication: {
      type: Boolean,
      required: true,
    },
    date: {
      type: String,
      default: null,
    },
    limitDate: {
      type: String,
      default: null,
    },
    publishedEndDate: {
      type: String,
      default: null,
    },
    isNewProject: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    shouldShowNewTag(): boolean {
      // 新着タグを表示させる条件
      // at 2021/05/07: 「募集終了」された場合、プロジェクトが最新かどうか(isNew)にかかわらず、「新着」は非表示
      // @see https://crowdworks.slack.com/archives/CHNLS0C00/p1620301066271300
      if (this.isClosingApplication) {
        return false
      }
      return this.isNewProject
    },
  },
})
